import { useState } from "react";
import { ReactTransliterate } from "react-transliterate";
import editIcon from "../../assests/icons/edit.jpg";
import deleteIcon from "../../assests/icons/delete.jpg";
import publishIcon from "../../assests/icons/publish.png";
import { isAdmin, isApprover, isPublisher } from "../utils/auth.js";
import parse from "html-react-parser";
import { showHideLoader, processImage } from "../utils/helper.js";
import {
  sliderObject,
  save,
  update,
  getPreview,
  getLive,
  deleteLive,
  deletePreview,
  publish,
} from "../../network/lib/slider.js";
import { Link } from "react-router-dom";

function Slider({ user }) {
  const [fileName, setFileName] = useState("");
  const [image, setImage] = useState("");
  const [previewData, setPreviewData] = useState();
  const [liveData, setLiveData] = useState();

  const [id, setId] = useState(0);

  const admin = isAdmin(user.roleId);
  const approver = isApprover(user.roleId);
  const publisher = isPublisher(user.roleId);

  const setToDefault = () => {
    setFileName("");
    setImage("");
    setId(0);
    setPreviewData(undefined);
    setLiveData(undefined);
  };

  const handleCancel = (e) => {
    e.preventDefault();
    resetMessage();
    setToDefault();
  };

  const resetMessage = () => {
    let message = document.getElementById("message");
    message.innerHTML = "";
    message.classList.replace("success", "alert");
    return message;
  };

  const handleEdit = (e) => {
    e.preventDefault();
    resetMessage();

    let dataParams = e.target.getAttribute("data-params");
    if (dataParams) {
      let params = JSON.parse(dataParams);
      setId(params.id);
      setFileName(params.fileName);
      setImage(params.image);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    let message = resetMessage();

    setLiveData(undefined);
    setPreviewData(undefined);

    if (fileName == "") {
      message.innerHTML = "Please provide File Name";
    } else if (image == "") {
      message.innerHTML = "Please select an image";
    } else {
      showHideLoader(true);

      sliderObject.id = id;
      sliderObject.fileName = fileName;
      sliderObject.image = image;
      sliderObject.userName = user.userName;

      if (id == 0) {
        save(sliderObject).then((res) => {
          if (res.status == 200 && res.data) {
            message.classList.replace("alert", "success");
            message.innerHTML = "Data saved successfully!!!";
            setToDefault();
          } else {
            message.innerHTML = "Some error occurred. Please try again";
          }
          showHideLoader();
        });
      } else {
        update(sliderObject).then((res) => {
          if (res.status == 200 && res.data) {
            message.classList.replace("alert", "success");
            message.innerHTML = "Data updated successfully!!!";
            setToDefault();
          } else {
            message.innerHTML = "Some error occurred. Please try again";
          }
          showHideLoader();
        });
      }
    }
  };

  const fetchPreviewData = () => {
    showHideLoader(true);

    getPreview()
      .then((resp) => {
        if (resp.status == 200) {
          setPreviewData(resp.data);
          setLiveData(undefined);
          showHideLoader();
        }
      })
      .catch((e) => console.log(e));
  };

  const handlePreviewData = (e) => {
    e.preventDefault();
    resetMessage();
    fetchPreviewData();
  };

  const fetchLiveData = () => {
    showHideLoader(true);

    getLive()
      .then((resp) => {
        if (resp.status == 200) {
          setLiveData(resp.data);
          setPreviewData(undefined);
          showHideLoader();
        }
      })
      .catch((e) => console.log(e));
  };

  const handleLiveData = (e) => {
    e.preventDefault();
    resetMessage();
    fetchLiveData();
  };

  const handleDeletePreview = (e) => {
    e.preventDefault();
    let message = resetMessage();
    if (window.confirm("Do you really want to delete the item from Preview?")) {
      let params = e.target.getAttribute("data-params");
      if (params) {
        sliderObject.id = parseInt(params);
        sliderObject.userName = user.userName;

        deletePreview(sliderObject).then((res) => {
          if (res.status == 200 && res.data) {
            fetchPreviewData();
          } else {
            message.innerHTML = "Some error occurred. Please try again";
          }
        });
      }
    }
  };

  const handleDeleteLive = (e) => {
    e.preventDefault();
    let message = resetMessage();
    if (
      window.confirm(
        "Do you really want to delete the item from Live? This will be moved to Preview."
      )
    ) {
      let params = e.target.getAttribute("data-params");
      if (params) {
        sliderObject.id = parseInt(params);
        sliderObject.userName = user.userName;

        deleteLive(sliderObject).then((res) => {
          if (res.status == 200 && res.data) {
            fetchLiveData();
          } else {
            message.innerHTML = "Some error occurred. Please try again";
          }
        });
      }
    }
  };

  const handlePublish = (e) => {
    e.preventDefault();
    let message = resetMessage();

    let params = e.target.getAttribute("data-params");
    if (params) {
      sliderObject.id = parseInt(params);
      sliderObject.userName = user.userName;

      publish(sliderObject).then((res) => {
        if (res.status == 200 && res.data) {
          fetchPreviewData();
          setToDefault();
        } else {
          message.innerHTML = "Some error occurred. Please try again";
        }
      });
    }
  };

  const handleImage = (e) => {
    processImage(e.target.files[0], resetMessage(), setImage);
  };

  const contents = (
    <>
      <table>
        <tbody>
          <tr>
            <th align="center" colSpan="4">
              Profile Setting
            </th>
          </tr>
          <tr>
            <td colSpan={4} align="right">
              <Link to="/admin/sitesetting">
                <span>Profile Setting</span>
              </Link>
            </td>
          </tr>
          <tr>
            <td align="right">
              <span className="required">File Name</span>
            </td>
            <td colSpan={3}>
              <ReactTransliterate
                renderComponent={(props) => (
                  <textarea {...props} rows="1" cols="108" />
                )}
                value={fileName}
                onChangeText={(text) => {
                  setFileName(text);
                }}
                lang="mr"
              />
            </td>
          </tr>
          <tr>
            <td align="right">
              <span className="required">Image</span>
            </td>
            <td>
              <label
                htmlFor="file-upload"
                className="custom-file-upload"
                style={{ width: "307px", textAlign: "center" }}
              >
                Browse
              </label>
              <input
                type="file"
                id="file-upload"
                accept="image/*"
                onChange={(e) => handleImage(e)}
              />
            </td>
            <td colSpan={2}>
              {image && (
                <img
                  src={image}
                  style={{ width: "150px", height: "150px", float: "left" }}
                />
              )}
            </td>
          </tr>
          <tr>
            <td colSpan={2}></td>
            <td style={{ textAlign: "right", paddingRight: "38px" }}>
              <input
                className="btn"
                type="submit"
                value="Cancel"
                id="btnCancel"
                onClick={handleCancel}
              />
              &nbsp;&nbsp;
              <input
                className="btn"
                type="submit"
                value="Submit"
                id="btnSubmit"
                onClick={handleSubmit}
              />
            </td>
            <td></td>
          </tr>
          <tr>
            <td colSpan="4" style={{ textAlign: "center" }}>
              <div
                id="message"
                className="alert"
                style={{ textAlign: "center" }}
              ></div>
            </td>
          </tr>
          <tr>
            <td></td>
            <td colSpan={2}>
              <input
                className="btn"
                type="submit"
                style={{ float: "left" }}
                value="View Preview"
                id="btnPreviewData"
                onClick={handlePreviewData}
              />
              &nbsp;&nbsp;
              <input
                className="btn"
                type="submit"
                value="View Live"
                id="btnLiveData"
                onClick={handleLiveData}
              />
            </td>
            <td></td>
          </tr>
        </tbody>
      </table>
      {previewData && (
        <table className="alternate-row">
          <thead>
            <tr>
              <th align="center" colSpan={admin ? 5 : approver ? 4 : 3}>
                Preview
              </th>
            </tr>
            <tr>
              <td colSpan={admin ? 5 : approver ? 4 : 3}></td>
            </tr>
          </thead>
          <tbody>
            <tr style={{ textAlign: "center" }}>
              {publisher && (
                <td>
                  <u>Publish</u>
                </td>
              )}
              <td>
                <u>File Name</u>
              </td>
              <td>
                <u>Image</u>
              </td>
              <td>
                <u>Edit</u>
              </td>
              {admin && (
                <td>
                  <u>Delete</u>
                </td>
              )}
            </tr>
            {previewData.length > 0 ? (
              previewData.map((x, i) => (
                <tr key={i} style={{ textAlign: "center" }}>
                  {publisher && (
                    <td>
                      <img
                        className="handle"
                        data-params={x.id}
                        onClick={handlePublish}
                        src={publishIcon}
                        alt="Publish"
                        border="0px"
                        style={{ width: "20px", height: "20px" }}
                      />
                    </td>
                  )}
                  <td>{x.fileName}</td>
                  <td>
                    {x.image &&
                      parse(`<img src=${x.image}  style="width: 60px"/>`)}
                  </td>
                  <td>
                    <img
                      className="handle"
                      data-params={JSON.stringify(x)}
                      onClick={handleEdit}
                      src={editIcon}
                      alt="Edit"
                      border="0px"
                      style={{ width: "20px", height: "20px" }}
                    />
                  </td>
                  {admin && (
                    <td>
                      <img
                        className="handle"
                        data-params={x.id}
                        onClick={handleDeletePreview}
                        src={deleteIcon}
                        alt="Delete"
                        border="0px"
                        style={{ width: "20px", height: "20px" }}
                      />
                    </td>
                  )}
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan={admin ? 5 : approver ? 4 : 3}
                  style={{ textAlign: "center" }}
                >
                  No Data available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      )}
      {liveData && (
        <table className="alternate-row">
          <thead>
            <tr>
              <th align="center" colSpan={admin ? 3 : 2}>
                Live
              </th>
            </tr>
            <tr>
              <td colSpan={admin ? 3 : 2}></td>
            </tr>
          </thead>
          <tbody>
            <tr style={{ textAlign: "center" }}>
              <td>
                <u>File Name</u>
              </td>
              <td>
                <u>Image</u>
              </td>
              {admin && (
                <td>
                  <u>Delete</u>
                </td>
              )}
            </tr>
            {liveData.length > 0 ? (
              liveData.map((x, i) => (
                <tr key={i} style={{ textAlign: "center" }}>
                  <td>{x.fileName}</td>
                  <td>
                    {x.image &&
                      parse(`<img src=${x.image}  style="width: 60px"/>`)}
                  </td>
                  {admin && (
                    <td>
                      <img
                        className="handle"
                        data-params={x.id}
                        onClick={handleDeleteLive}
                        src={deleteIcon}
                        alt="Delete"
                        border="0px"
                        style={{ width: "20px", height: "20px" }}
                      />
                    </td>
                  )}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={admin ? 3 : 2} style={{ textAlign: "center" }}>
                  No Data available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      )}
    </>
  );

  return contents;
}

export default Slider;
